import {
  PublicClientApplication,
  EventType,
  EventMessage,
  AuthenticationResult,
} from "@azure/msal-browser";
import {
  msalStaffConfig,
  msalStudentConfig,
} from "../../layout/login/auth/authConfig";
import { sessionRepository } from "../../services/sessionRepository";

export class AuthFunctions {
  static InitializeMsal = async (role: string) => {
    const msalInstance =
      role === "student"
        ? new PublicClientApplication(msalStudentConfig)
        : new PublicClientApplication(msalStaffConfig);

    await msalInstance.initialize();

    //set the account
    msalInstance.addEventCallback((event: EventMessage) => {
      if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
        const authenticationResult = event.payload as AuthenticationResult;
        const account = authenticationResult.account;
        msalInstance.setActiveAccount(account);
      }
    });

    //enable account storage event
    //msalInstance.enableAccountStorageEvents();
    return msalInstance;
  };
}
